import React, { useEffect, useRef } from "react";
import translate from "@deosite/helpers/langLibrary";

import Box from "@commerce-ui/core2/Box";
import Grid from "@commerce-ui/core2/Grid";
import Container from "@commerce-ui/core2/Container";

import PageContainer from "../../containers/UI/PageContainer";

import CollectionCard from "../../components/CollectionCard";
import SectionWithConfigurableHeader from "../../sections/SectionWithConfigurableHeader";

const CollectionsListPage = props => {
  const {
    collectionCategoryName,
    backLabel,
    backClickFunction,
    footerContent,
    dataRequiredToHideLoader,
    collections
  } = props;

  const translations = {
    collections: translate("Collections"),
    seoDescription: translate("Default seo description"),
    seoTitle: translate("Default seo title")
  };

  return (
    <PageContainer
      footerContent={footerContent}
      returnLinkLabel={backLabel}
      onReturnLabelClick={backClickFunction}
      metaTagsData={{
        description: translations.seoDescription,
        title: translations.seoTitle
      }}
      dataRequiredToHideLoader={dataRequiredToHideLoader}
    >
      <SectionWithConfigurableHeader title={collectionCategoryName}>
        <Container>
          {collections && (
            <Grid cols={20}>
              {collections.map((collection, index) => (
                <Box
                  sx={{
                    marginBottom: "s11",
                    gridColumn: ["span 20", null, "4 / span 14", null]
                  }}
                  key={index}
                >
                  <CollectionCard collection={collection} />
                </Box>
              ))}
            </Grid>
          )}
        </Container>
      </SectionWithConfigurableHeader>
    </PageContainer>
  );
};

export default CollectionsListPage;
